export default __webpack_public_path__ + "static/media/mc-bank-rus.b02c080b.svg";